import { Box, Button, Modal } from "@mui/material";
import { User, UserRoles } from "../../types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Input } from "../../hookFormComponents.tsx/Input";
import { api } from "../../api/api";

type Props = {
  modalConfig: { open: boolean; data: any };
  handleClose: () => void;
  setModalConfig: React.Dispatch<
    React.SetStateAction<
      | {
          data?: any;
          open: boolean;
        }
      | undefined
    >
  >;
  fetcher: () => Promise<void>;
};

function CreateModal({
  modalConfig,
  handleClose,
  fetcher,
  setModalConfig,
}: Props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "white",
    boxShadow: 24,
    borderRadius: "10px",
    p: 4,
  };

  const validationSchema1 = Yup.object({
    name: Yup.string().required("Required"),
  });

  const {
    formState: { errors },
    control,
    setValue,
    register,
    handleSubmit,
    getValues,
  } = useForm<Yup.InferType<typeof validationSchema1>>({
    resolver: yupResolver(validationSchema1),
    defaultValues: modalConfig.data
      ? {
          name: modalConfig.data.name,
        }
      : {},
  });

  console.log(errors);
  return (
    <Modal open={modalConfig.open} onClose={handleClose}>
      <Box sx={style}>
        <form
          noValidate
          onSubmit={handleSubmit((values) => {
            if (modalConfig.data) {
              api
                .post(`/equipment/${modalConfig.data.id}/update`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            } else {
              api
                .post(`/equipment/create`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            }
          })}
        >
          <Input
            required
            {...register("name")}
            label={"Name"}
            type="text"
            error={errors?.name?.message}
          />
          <Box sx={{ display: "flex", justifyContent: "right" }}>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default CreateModal;
